/* eslint-disable no-useless-catch */
import api from '../../../api'
import types from './siteTypes'

const actions = {
  clearAllSites(context) {
    context.commit(types.CLEAR_SITES)
  },

  async getAllSites(context, payload) {
    try {
      context.dispatch('showLoader')
      context.commit(types.CLEAR_SITES)
      const options = {}
      if (payload.page) options.page = payload.page
      if (payload.limit) options.limit = payload.limit
      if (payload.sort) options.sort = payload.sort
      const response = await api.site.getAll(payload.organizationId, options)

      context.commit(types.SET_SITES, {
        sites: response.data.results,
      })

      context.dispatch('hideLoader')
      return response.data
    } catch (err) {
      context.dispatch('hideLoader')
      throw err
    }
  },

  async getSite(context, payload) {
    try {
      context.commit(types.CLEAR_ACTIVE_SITE)

      const response = await api.site.getById(
        payload.organizationId,
        payload.siteId
      )

      context.commit(types.SET_ACTIVE_SITE, {
        site: response.data,
      })

      return response.data
    } catch (err) {
      throw err
    }
  },

  async updateSite(context, payload) {
    try {
      context.dispatch('showLoader')

      const siteData = payload.data

      const response = await api.site.update(
        payload.organizationId,
        payload.siteId,
        siteData
      )
      context.dispatch('hideLoader')

      context.commit(types.SET_ACTIVE_SITE, {
        site: response.data,
      })

      return response.data
    } catch (err) {
      context.dispatch('hideLoader')
      throw err
    }
  },
}

export default actions
